<div class="not-found-screen">
	<div class="not-found-center">
		<img src="assets/images/logo-tellco.png" class="splash-screen-image responsive" />
		<div class="not-found-width center">
			<h1>404 <i>Page not found. </i></h1>
		</div>
	</div>
</div>
